import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, Link } from "react-router-dom";

const SITE_URL = "https://www.windenergybridge.com";

const SEGMENT_LABELS: Record<string, string> = {
  "about-us": "About Us",
  services: "Services",
  "for-developers": "For Developers",
  "for-suppliers": "For Suppliers",
  "for-investors": "For Investors",
  "for-insurers": "For Insurers",
  career: "Career",
  "contact-us": "Contact Us",
  insights: "Insights",
  articles: "Articles",
  weekly: "Weekly",
  events: "Events",
  gwsce: "GWSCE",
  policies: "Policies",
  "terms-and-conditions": "Terms & Conditions",
  "privacy-policy": "Privacy Policy",
  "cookies-policy": "Cookies Policy",
};

function slugToLabel(slug: string): string {
  if (SEGMENT_LABELS[slug]) return SEGMENT_LABELS[slug];
  return slug
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export default function Breadcrumbs() {
  const { pathname } = useLocation();

  if (pathname === "/") return null;

  const segments = pathname.replace(/\/$/, "").split("/").filter(Boolean);

  const crumbs = [
    { label: "Home", path: "/" },
    ...segments.map((seg, i) => ({
      label: slugToLabel(seg),
      path: "/" + segments.slice(0, i + 1).join("/"),
    })),
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: crumb.label,
      item: `${SITE_URL}${crumb.path}`,
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <nav
        aria-label="Breadcrumb"
        className="breadcrumbs-nav"
      >
        <ol>
          {crumbs.map((crumb, i) => (
            <li key={crumb.path}>
              {i > 0 && <span aria-hidden="true">/</span>}
              {i < crumbs.length - 1 ? (
                <Link to={crumb.path}>{crumb.label}</Link>
              ) : (
                <span aria-current="page">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
